module.exports = __webpack_public_path__ + "static/media/ic-clock.b143dfb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-clock.svg
// module id = 612
// module chunks = 14